import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import App from './App.tsx'
import { iniciarAutoActualizacion } from '@/lib/actualizacion'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// ── Actualización automática ─────────────────────────────────────────────────
// Un despliegue nuevo llega solo, al volver la app a primer plano. Ver
// `lib/actualizacion.ts` para por qué se aplica en ese momento y no en cualquiera.
iniciarAutoActualizacion();

// ── Service Worker · SOLO fotos del catálogo ─────────────────────────────────
// Estuvo desactivado por una razón buena: la versión anterior cacheaba el «app
// shell» y servía builds viejos («no arranca» / interfaz obsoleta tras cada
// deploy). El `sw.js` actual NO guarda nada de la aplicación —ni HTML, ni JS,
// ni llamadas a la API—: solo intercepta las fotos de platos de Firebase
// Storage. No puede servir un build rancio porque no guarda ningún build.
//
// Se registra después de `load` para no competir por ancho de banda con el
// arranque, que es lo que se quiere acelerar.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`)
      .catch(() => { /* sin SW la app funciona igual, solo pide más red */ });
  });
}
